import Mind from './Mind'

export default Mind
// eslint-disable-next-line import/export
export * from './Mind'
